import React, { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import './PhonePage.scss'
import { CrossIcon } from '../../assets/icons'
import { useNavigate } from 'react-router-dom'
import useIsMobileSize from '@/hooks/useIsMobileSize'
import ButtonIcon from '@/components/ui/ButtonIcon/ButtonIcon'
import { i18n } from '@/locale/i18n'

// Drawer: rises from the bottom edge. Same motion as the desktop notification
// popover — a spring in, a shorter tween out.
const ENTER_SECONDS = 0.3
const EXIT_SECONDS = 0.1

const PhonePage = ({ children, title, onClose }) => {
  const navigate = useNavigate()
  const isMobileSize = useIsMobileSize()
  const [isLeaving, setIsLeaving] = useState(false)

  if (!isMobileSize) return children

  // Close only arms the exit — the drawer has to finish sliding down before the
  // route changes, so the navigation runs from onExitComplete.
  const handleCloseClick = () => setIsLeaving(true)

  const handleExitComplete = () => {
    if (onClose) {
      onClose()
    } else {
      navigate(-1)
    }
  }

  return (
    <AnimatePresence onExitComplete={handleExitComplete}>
      {!isLeaving && (
        <motion.div
          className="phone-page"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%', transition: { type: 'tween', duration: EXIT_SECONDS, ease: 'easeIn' } }}
          transition={{ type: 'spring', visualDuration: ENTER_SECONDS, bounce: 0 }}
        >
          <header className="phone-page-header">
            <h2>{title}</h2>
            <ButtonIcon
              className="phone-page-close"
              size="large"
              cursorPointer
              highlightOnHover
              ariaLabel={i18n('common.close')}
              handleOnClick={handleCloseClick}
            >
              <CrossIcon />
            </ButtonIcon>
          </header>
          <div className="phone-page-body">{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default PhonePage
